module.exports = "/assets/data/f189f5fdfbe9213801a5907a4582bd69-IG5.data.json";